import React, { useContext } from 'react'
import { PDPContext } from '../../context'
import { connectToLocale, ProductBetterTogether as PDPBetterTogether } from '@insight/toolkit-react'
import { getCreateAccountURL, getLoginURL } from '@insight/toolkit-utils';
import { hideLoggedOutPricingFF } from '../../shared'
export const ProductBetterTogether = ({context}) => {
  const { product = {}, addToCart, isLoggedIn, showVAT, setMiniPDP, recommendations = {} } = useContext(PDPContext)
  const { better_together } = recommendations
  const { permissions, isIPSUser, userInformation, webGroupPermissions} = context
  return <PDPBetterTogether
      product={product}
      addToCart={addToCart}
      better_together={better_together}
      permissions={permissions}
      isIPSUser={isIPSUser}
      isLoggedIn={isLoggedIn}
      showVAT={showVAT}
      webGroupPermissions={webGroupPermissions}
      setMiniPDP={setMiniPDP}
      webGroupId={userInformation?.webGroup?.webGroupId}
      showPrice={!hideLoggedOutPricingFF()}
      loginLink={getLoginURL()}
      accountLink={getCreateAccountURL()}
    />;
}

export default connectToLocale(ProductBetterTogether)
